import { DispatchType, StoreAction, StoreState } from "../reduxTypes";
import { Error202, parseError } from "../../utils/http-helper";
import extratoRepasseService from "../../services/extratoRepasse";
import { getSession } from "../../utils/session-helper";

const _inicio = "DEM_FIN_ATUAL__";
export const DEM_FIN_ATUAL__INICIALIZA_ESTADO = _inicio + "INICIALIZA_ESTADO";
export const DEM_FIN_ATUAL__SET_DADOS_EXTRATO = _inicio + "SET_DADOS_EXTRATO";
export const DEM_FIN_ATUAL__SET_CONTRATOS = _inicio + "SET_CONTRATOS";
export const DEM_FIN_ATUAL__SET_DATAS_PAGAMENTO =
  _inicio + "SET_DATAS_PAGAMENTO";
export const DEM_FIN_ATUAL__SET_PROCEDIMENTOS = _inicio + "SET_PROCEDIMENTOS";
export const DEM_FIN_ATUAL__SET_REL_PRODUTIVIDADE =
  _inicio + "SET_REL_PRODUTIVIDADE";
export const DEM_FIN_ATUAL__SET_REL_SINTETICO = _inicio + "SET_REL_SINTETICO";
export const DEM_FIN_ATUAL__SET_PLANTOES_NORMAIS =
  _inicio + "SET_PLANTOES_NORMAIS";
export const DEM_FIN_ATUAL__SET_PLANTOES_SOBREAVISO =
  _inicio + "SET_PLANTOES_SOBREAVISO";
export const DEM_FIN_ATUAL__SET_PLANTOES_NORMAIS_RESUMO =
  _inicio + "SET_PLANTOES_NORMAIS_RESUMO";
export const DEM_FIN_ATUAL__SET_PLANTOES_SOBREAVISO_RESUMO =
  _inicio + "SET_PLANTOES_SOBREAVISO_RESUMO";
export const DEM_FIN_ATUAL__SET_PRODUCOES_NORMAIS =
  _inicio + "SET_PRODUCOES_NORMAIS";
export const DEM_FIN_ATUAL__SET_PRODUCOES_SOBREAVISO =
  _inicio + "SET_PRODUCOES_SOBREAVISO";
export const DEM_FIN_ATUAL__SET_DETALHAMENTOS_EXTRA =
  _inicio + "SET_DETALHAMENTOS_EXTRA";
export const DEM_FIN_ATUAL__SET_FILTROS = _inicio + "SET_FILTROS";
export const DEM_FIN_ATUAL__LIMPAR_FILTROS = _inicio + "LIMPAR_FILTROS";
export const DEM_FIN_ATUAL__SET_LOADING = _inicio + "SET_LOADING";

function setFiltros(dados: {
  dataPagamento: string;
  contrato: string | undefined;
}): StoreAction {
  return {
    type: DEM_FIN_ATUAL__SET_FILTROS,
    payload: dados,
  };
}

function setDemonstrativo(dados: Object): StoreAction {
  return {
    type: DEM_FIN_ATUAL__SET_DADOS_EXTRATO,
    payload: dados,
  };
}

function setContratos(dados: Object): StoreAction {
  return {
    type: DEM_FIN_ATUAL__SET_CONTRATOS,
    payload: dados,
  };
}

function setDatasPagamento(dados: Object): StoreAction {
  return {
    type: DEM_FIN_ATUAL__SET_DATAS_PAGAMENTO,
    payload: dados,
  };
}

function setRelProdutividade(dados: Object): StoreAction {
  return {
    type: DEM_FIN_ATUAL__SET_REL_PRODUTIVIDADE,
    payload: dados,
  };
}

function setRelSintetico(dados: Object): StoreAction {
  return {
    type: DEM_FIN_ATUAL__SET_REL_SINTETICO,
    payload: dados,
  };
}

function setProcedimentos(dados: Object): StoreAction {
  return {
    type: DEM_FIN_ATUAL__SET_PROCEDIMENTOS,
    payload: dados,
  };
}

function setPlantoesNormais(dados: Object): StoreAction {
  return {
    type: DEM_FIN_ATUAL__SET_PLANTOES_NORMAIS,
    payload: dados,
  };
}

function setPlantoesNormaisResumo(dados: Object): StoreAction {
  return {
    type: DEM_FIN_ATUAL__SET_PLANTOES_NORMAIS_RESUMO,
    payload: dados,
  };
}

function setPlantoesSobreaviso(dados: Object): StoreAction {
  return {
    type: DEM_FIN_ATUAL__SET_PLANTOES_SOBREAVISO,
    payload: dados,
  };
}

function setPlantoesSobreavisoResumo(dados: Object): StoreAction {
  return {
    type: DEM_FIN_ATUAL__SET_PLANTOES_SOBREAVISO_RESUMO,
    payload: dados,
  };
}

function setProducoesNormais(dados: Object): StoreAction {
  return {
    type: DEM_FIN_ATUAL__SET_PRODUCOES_NORMAIS,
    payload: dados,
  };
}

function setProducoesSobreaviso(dados: Object): StoreAction {
  return {
    type: DEM_FIN_ATUAL__SET_PRODUCOES_SOBREAVISO,
    payload: dados,
  };
}

function setDetalhamentosExtra(dados: Object): StoreAction {
  return {
    type: DEM_FIN_ATUAL__SET_DETALHAMENTOS_EXTRA,
    payload: dados,
  };
}

function setRequisitado(): StoreAction {
  return { type: DEM_FIN_ATUAL__INICIALIZA_ESTADO };
}

function limparFiltros(): StoreAction {
  return { type: DEM_FIN_ATUAL__LIMPAR_FILTROS };
}

function setLoading(l: boolean): StoreAction {
  return {
    type: DEM_FIN_ATUAL__SET_LOADING,
    payload: l,
  };
}

function buscarContratos() {
  return async function (dispatch: DispatchType, getState: () => StoreState) {
    const { userData } = await getSession();
    if (!userData) return;
    // dispatch(startLoading());
    const {
      extratoRepasseState: { filtros },
    } = getState();

    return extratoRepasseService
      .buscarContratos(userData.CPF)
      .then((resp) => {
        const { data } = resp;

        dispatch(setDatasPagamento([]));
        if (typeof data === typeof []) {
          dispatch(setContratos(data));
          if (data.length > 0) {
            dispatch(
              setFiltros({
                ...filtros,
                contrato: data[0].ID,
                dataPagamento: "",
              })
            );
          }
        } else {
          dispatch(setContratos([]));
          dispatch(
            setFiltros({
              ...filtros,
              contrato: "0",
              dataPagamento: "",
            })
          );
        }
      })
      .catch((error) => {
        parseError(error, "Erro ao tentar conectar");
      })
      .finally(() => {
        // dispatch(stopLoading());
      });
  };
}

function buscarDatasRemessa(contrato: string) {
  return async function (dispatch: DispatchType, getState: () => StoreState) {
    const { userData } = await getSession();
    if (!userData) return;

    const {
      extratoRepasseState: { filtros },
    } = getState();

    return extratoRepasseService
      .buscarDatasPagamento(userData.CPF, contrato)
      .then((resp) => {
        const { data } = resp;

        if (typeof data === typeof []) {
          dispatch(setDatasPagamento(data));
          dispatch(
            setFiltros({
              ...filtros,
              dataPagamento: data[0].substring(0, 10),
            })
          );
        } else {
          dispatch(setDatasPagamento([]));
          dispatch(
            setFiltros({
              ...filtros,
              dataPagamento: "",
            })
          );
        }
      })
      .catch((error) => {
        parseError(error, "Erro ao tentar conectar");
      });
  };
}

function buscarDemonstrativo(contrato: string, dataPagamento: string) {
  return async function (dispatch: DispatchType) {
    const { userData } = await getSession();
    if (!userData) return;

    dispatch(setLoading(true));
    return extratoRepasseService
      .buscarExtratosRepasseDetalhado(userData.CPF, contrato, dataPagamento)
      .then((resp) => {
        const {
          data: {
            Extrato,
            PlantoesNormais,
            PlantoesNormalResumoTurno,
            PlantoesSobreAviso,
            PlantoesSobreAvisoResumoTurno,
            Procedimentos,
            ProducoesNormalLinha,
            ProducoesSobreAvisoLinha,
            Produtividades,
            ExtratoSintetico,
            DetalhamentosExtra,
          },
        } = resp;

        if (Extrato) {
          dispatch(setDemonstrativo(Extrato));
        }
        if (PlantoesNormais) {
          dispatch(setPlantoesNormais(PlantoesNormais));
        }
        if (PlantoesNormalResumoTurno) {
          dispatch(setPlantoesNormaisResumo(PlantoesNormalResumoTurno));
        }
        if (PlantoesSobreAviso) {
          dispatch(setPlantoesSobreaviso(PlantoesSobreAviso));
        }
        if (PlantoesSobreAvisoResumoTurno) {
          dispatch(setPlantoesSobreavisoResumo(PlantoesSobreAvisoResumoTurno));
        }
        if (Procedimentos) {
          dispatch(setProcedimentos(Procedimentos));
        }
        if (ProducoesNormalLinha) {
          dispatch(setProducoesNormais(ProducoesNormalLinha));
        }
        if (ProducoesSobreAvisoLinha) {
          dispatch(setProducoesSobreaviso(ProducoesSobreAvisoLinha));
        }
        if (Produtividades) {
          dispatch(setRelProdutividade(Produtividades));
        }
        if (ExtratoSintetico) {
          dispatch(setRelSintetico(ExtratoSintetico));
        }
        if (DetalhamentosExtra) {
          dispatch(setDetalhamentosExtra(DetalhamentosExtra));
        }
      })
      .catch((error) => {
        parseError(error, "Erro ao tentar conectar");
      })
      .finally(() => dispatch(setLoading(false)));
  };
}

function inicializaEstado() {
  return async function (dispatch: DispatchType, getState: () => StoreState) {
    const { userData } = await getSession();
    if (!userData) return;

    try {
      const {
        demonstrativoFinanceiroState: { filtros, requisitado },
      } = getState();
      const filtrosIniciais = { ...filtros };
      if (!requisitado) {
        dispatch(setRequisitado());
      }

      const { data: respContratos } =
        await extratoRepasseService.buscarContratos(userData.CPF);

      if (
        !respContratos ||
        typeof respContratos !== typeof [] ||
        respContratos.length === 0
      ) {
        throw new Error202("Nenhum Contrato encontrado no período");
      }

      dispatch(setContratos(respContratos));
      filtrosIniciais.contrato = respContratos[0].ID.toString();

      const { data: respDatasPagamento } =
        await extratoRepasseService.buscarDatasPagamento(
          userData.CPF,
          filtrosIniciais.contrato
        );

      if (
        !respDatasPagamento ||
        typeof respDatasPagamento !== typeof [] ||
        respDatasPagamento.length === 0
      ) {
        dispatch(setFiltros({ ...filtrosIniciais, dataPagamento: "" }));
        throw new Error202("Nenhuma Data de Pagamento encontrado no período");
      }

      filtrosIniciais.dataPagamento = respDatasPagamento[0].substring(0, 10);
      dispatch(setDatasPagamento(respDatasPagamento));

      dispatch(setFiltros(filtrosIniciais));

      extratoRepasseService
        .buscarExtratosRepasseDetalhado(
          userData.CPF,
          filtrosIniciais.contrato,
          filtrosIniciais.dataPagamento
        )
        .then((resp) => {
          const {
            data: {
              Extrato,
              PlantoesNormais,
              PlantoesNormalResumoTurno,
              PlantoesSobreAviso,
              PlantoesSobreAvisoResumoTurno,
              Procedimentos,
              ProducoesNormalLinha,
              ProducoesSobreAvisoLinha,
              Produtividades,
              ExtratoSintetico,
              DetalhamentosExtra,
            },
          } = resp;

          if (Extrato) {
            dispatch(setDemonstrativo(Extrato));
          }
          if (PlantoesNormais) {
            dispatch(setPlantoesNormais(PlantoesNormais));
          }
          if (PlantoesNormalResumoTurno) {
            dispatch(setPlantoesNormaisResumo(PlantoesNormalResumoTurno));
          }
          if (PlantoesSobreAviso) {
            dispatch(setPlantoesSobreaviso(PlantoesSobreAviso));
          }
          if (PlantoesSobreAvisoResumoTurno) {
            dispatch(
              setPlantoesSobreavisoResumo(PlantoesSobreAvisoResumoTurno)
            );
          }
          if (Procedimentos) {
            dispatch(setProcedimentos(Procedimentos));
          }
          if (ProducoesNormalLinha) {
            dispatch(setProducoesNormais(ProducoesNormalLinha));
          }
          if (ProducoesSobreAvisoLinha) {
            dispatch(setProducoesSobreaviso(ProducoesSobreAvisoLinha));
          }
          if (Produtividades) {
            dispatch(setRelProdutividade(Produtividades));
          }
          if (ExtratoSintetico) {
            dispatch(setRelSintetico(ExtratoSintetico));
          }
          if (DetalhamentosExtra) {
            dispatch(setDetalhamentosExtra(DetalhamentosExtra));
          }
        })
        .catch((error) => {
          parseError(error, "Erro ao tentar conectar");
        });
    } catch (erro) {
      parseError(erro, "Erro ao tentar conectar");
    }
  };
}

const extratoRepasseActions = {
  inicializaEstado,
  setFiltros,
  limparFiltros,
  buscarContratos,
  buscarDatasRemessa,
  buscarDemonstrativo,
};

export default extratoRepasseActions;
